<div class="py-4 px-0">
  <div class="container">
    <a routerLink="../" class="d-inline-block mb-4">&lsaquo; {{ "common.goBack" | translate }}</a>

    <h1>{{ "demo.educationalMaterial.reviews.title" | translate }}</h1>

    @if (ratings) {
      <h2>{{ ratings.name[lang] }}</h2>
      @if (ratings?.ratings?.length > 0) {
        <div class="averages">
          <div class="row">
            <div class="col-auto number-rating">
              <h3>{{ "demo.educationalMaterial.reviews.review.ratingContent" | translate }}</h3>
              @if (ratings.averages.content) {
                <span class="value">
                  {{ ratings.averages.content }}
                  <span class="text-muted">/ 5</span>
                </span>
              } @else {
                <span class="value text-muted">&ndash;</span>
              }
            </div>
            <div class="col-auto number-rating">
              <h3>{{ "demo.educationalMaterial.reviews.review.ratingVisual" | translate }}</h3>
              @if (ratings.averages.visual) {
                <span class="value">
                  {{ ratings.averages.visual }}
                  <span class="text-muted">/ 5</span>
                </span>
              } @else {
                <span class="value text-muted">&ndash;</span>
              }
            </div>
            <div class="col-auto number-rating">
              <h3>{{ "demo.educationalMaterial.reviews.review.reviews" | translate }}</h3>
              <span class="value count">{{ ratings.ratingsCount }}</span>
            </div>
          </div>
        </div>
        @for (rating of ratings.ratings; track rating) {
          <div class="rating">
            <div class="row justify-content-between mb-4">
              <div class="col-auto">
                <time [attr.datetime]="rating.updatedAt | date: 'yyyy-MM-dd HH:mm'" class="date">
                  {{ rating.updatedAt | date: "d.M.yyyy HH:mm" }}
                </time>
              </div>
              <div class="col-auto">
                <span class="author">{{ rating.firstName }} {{ rating.lastName }}</span>
              </div>
            </div>
            <div class="row mb-4">
              <div class="col-auto number-rating">
                <h3>{{ "demo.educationalMaterial.reviews.review.ratingContent" | translate }}</h3>
                @if (rating.ratingContent) {
                  <span class="value">{{ rating.ratingContent }}</span>
                } @else {
                  <span class="value text-muted">&ndash;</span>
                }
              </div>
              <div class="col-auto number-rating">
                <h3>{{ "demo.educationalMaterial.reviews.review.ratingVisual" | translate }}</h3>
                @if (rating.ratingVisual) {
                  <span class="value">{{ rating.ratingVisual }}</span>
                } @else {
                  <span class="value text-muted">&ndash;</span>
                }
              </div>
            </div>
            <ng-container>
              <h3>{{ "demo.educationalMaterial.reviews.review.feedbackPositive" | translate }}</h3>
              @if (rating.feedbackPositive) {
                <p>{{ rating.feedbackPositive }}</p>
              } @else {
                <p>&ndash;</p>
              }
            </ng-container>
            <ng-container>
              <h3>{{ "demo.educationalMaterial.reviews.review.feedbackSuggest" | translate }}</h3>
              @if (rating.feedbackSuggest) {
                <p>{{ rating.feedbackSuggest }}</p>
              } @else {
                <p>&ndash;</p>
              }
            </ng-container>
            <ng-container>
              <h3>{{ "demo.educationalMaterial.reviews.review.feedbackPurpose" | translate }}</h3>
              @if (rating.feedbackPurpose) {
                <p>{{ rating.feedbackPurpose }}</p>
              } @else {
                <p>&ndash;</p>
              }
            </ng-container>
          </div>
        }
      } @else {
        <p>{{ "demo.educationalMaterial.reviews.noRatings" | translate }}</p>
      }
    }
  </div>
</div>
